.c-select {
  --value-right-padding: 2rem;
  width: 100%;

  min-width: 0; /* Important to adjust to parent size (https:/*css-tricks.com/flexbox-truncated-text/) */ font-weight: 400;
}

  .c-select__dropdown {
    position: relative;
  }

  .c-select__value {
    cursor: pointer;
    text-align: left;
    width: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    user-select: none;

    padding-right: var(--value-right-padding);
  }

  @media print {

  .c-select__value {
    padding-right: 0.625rem;
  }
}

  .c-select__value::after {
      width: 0.95em;
      height: 0.95em;
      opacity: 0.5;
      /* fa-angle-down */
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path d='M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z'/></svg>");
      background-position: center;
      background-repeat: no-repeat;
      content: "";
      display: block;
      position: absolute;
      right: 13px;
    }

  @media print {

  .c-select__value::after {
    display: none;
  }
}

  .c-select__label,
  .c-select__placeholder {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* ensure empty select takes the regular input height */

  .c-select__label:empty::after, .c-select__placeholder:empty::after {
      content: '\feff';
    }

  .c-select__placeholder {
    color: #71717a;
  }

  .c-select__deselect {
  font-size: 1.25rem;
  line-height: 1.75rem;
    padding: 0 3px;
    position: absolute;
    top: 0;
    right: 1.3em;
    display: none;
    height: 100%;
    align-items: center;
    outline: none;
}

  .c-select__deselect::after {
      width: 0.75em;
      height: 0.75em;
      opacity: 0.5;
      /* FontAwesome xmark */
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path d='M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z'/></svg>");
      background-position: center;
      background-repeat: no-repeat;
      content: "";
      display: block;
    }

  @media print {

  .c-select__deselect::after {
    display: none;
  }
}

  .c-select__deselect:hover::after {
        opacity: 0.7;
      }

  .c-select__list {
    margin: 4px 0 0 0;
    min-width: 100% !important; /* override .dropdown min-width */
    max-width: 300px;
  }

  .c-select__select {
    /* Make invisible, using this instead of display:none to make sure */
    /* the focus events still work on the select. */
    opacity: 0;
    height: 0 !important;
    width: 0 !important;
    overflow: hidden;
    position: absolute;
    border: 0;
  }

  .c-select.open .c-select__list {
      display: block;
    }

  .c-select.open:not(.c-select--as-button) .c-select__value {
  --tw-border-opacity: 1 !important;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
  --tw-ring-opacity: 0.5;
      outline: 0;
}

  .c-select.disabled .c-select__value {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1)) !important;
  cursor: not-allowed;
}

  .c-select.invalid .c-select__value {
      /* make sure this matches with the invalid styling in forms.css */
      --tw-border-opacity: 1 !important;
      border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
      --tw-text-opacity: 1 !important;
      color: rgb(127 29 29 / var(--tw-text-opacity, 1)) !important;
    }

  .c-select.invalid .c-select__value::placeholder {
  --tw-placeholder-opacity: 1 !important;
  color: rgb(252 165 165 / var(--tw-placeholder-opacity, 1)) !important;
}

  .c-select.invalid .c-select__value:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1)) !important;
  --tw-ring-opacity: 0.5 !important;
}

  .c-select--with-deselect .c-select__value {
      padding-right: 2.6rem;
    }

  @media print {

  .c-select--with-deselect .c-select__value {
    padding-right: 0.625rem;
  }
}

  .c-select--as-button .c-select__label,
    .c-select--as-button .c-select__placeholder {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));

      line-height: 1.25rem;
      padding: 8px 32px 8px 9px;
      max-width: 250px;
      text-overflow: ellipsis;
      min-height: initial;
}

/*# sourceMappingURL=data:application/json;base64,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 */